module.exports = __webpack_public_path__ + "img/41400.0720a903.jpg";